import { API_G_060_SHUKKA_JUNBI } from '@/constants/api';
import axios from '@/plugins/axios';
import { removeBlankOrNullOrZero } from '@/utils/utils';
import type { Module } from 'vuex';

const g_060: Module<unknown, unknown> = {
  namespaced: true,
  state() {
    return {};
  },
  mutations: {},
  getters: {},
  actions: {
    async getJunbi(_ctx, params) {
      try {
        const { kaigaiKobetsuKb, ...newParams } = params;
        const res = await axios({
          url: `${API_G_060_SHUKKA_JUNBI}/junbi`,
          method: 'GET',
          params: {
            ...removeBlankOrNullOrZero(newParams),
            kaigaiKobetsuKb,
          },
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getJunbi error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async putIkkatsu(_ctx, requestData) {
      try {
        const res = await axios({
          url: `${API_G_060_SHUKKA_JUNBI}/ikkatsu`,
          data: {
            requestData,
          },
          method: 'PUT',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putIkkatsu error.');
        console.log(err);
      }
    },
    async getUchiwake(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_060_SHUKKA_JUNBI}/uchiwake`,
          method: 'GET',
          params,
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getUchiwake error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async putShukkoIraisho(_ctx, requestData) {
      try {
        const res = await axios({
          url: `${API_G_060_SHUKKA_JUNBI}/shukkoIraisho`,
          data: {
            requestData,
          },
          method: 'PUT',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putShukkoIraisho error.');
        console.log(err);
      }
    },
    async putHaisoIraisho(_ctx, requestData) {
      try {
        const res = await axios({
          url: `${API_G_060_SHUKKA_JUNBI}/haisoIraisho`,
          data: {
            requestData,
          },
          method: 'PUT',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putHaisoIraisho error.');
        console.log(err);
      }
    },
  },
};

export default g_060;
